import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import { App } from './components/App';

const environment = document.querySelector<HTMLMetaElement>('meta[name="environment"]')?.content ?? 'dev';

Sentry.init({
  dsn: 'https://cdecfc118b406500617d003143cd83cb@o144582.ingest.sentry.io/4506123473387520',
  environment,
  integrations: [new Sentry.BrowserTracing()],
  // Performance Monitoring
  tracesSampleRate: 0.1, // Capture 10% of the transactions
});

async function main() {
  document.addEventListener('DOMContentLoaded', () => {
    ReactDOM.render(<App />, document.getElementById('root'));
  });
}

main();
